import './ClaimSubmissionSummary.scss';
import { MotifIcon } from '@ey-xd/motif-react';
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb';
import Banner, { BannerElement } from '@/components/Banner/Banner';
import { useCase } from "@/features/case/use-case";
import { useTranslation } from 'react-i18next';
import { ActiveTabsOrder } from "@/menuData";

const mockHeaderSummaries: Record<string, any> = {
  "SUBM-001": {
    creditorName: "Pete Samson",
    debtorName: "Acme Debtor Ltd",
    submissionDate: "2024-12-12",
    status: "Submitted",
    claimId: "1001"
  },
  "SUBM-002": {
    creditorName: "Jane Doe",
    debtorName: "Beta Ltd",
    submissionDate: "2024-12-10",
    status: "Pending",
    claimId: "1002"
  },
};

function ClaimSubmissionSummaryHeader({
  caseId,
  submissionId
}: {
  caseId: string;
  submissionId: string;
}) {
  const { t } = useTranslation();
  const caseData = useCase(caseId);

  const mockData = mockHeaderSummaries[submissionId] || {};
  const breadcrumbItems = [
    {
      label: "External Submission",
      value: "10 New Creditor Submission",
      elementKey: "submission",
      text: caseData?.caseName || t("pages.creditors.creditorSummaryBreadCrums.backToCase"),
      url: `/case/${caseId}?activeTab=${ActiveTabsOrder.SUBMISSIONMANAGEMENT}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      label: "External Submission",
      value: "10 New Creditor Submission",
      elementKey: "submission",
      text: mockData?.creditorName || "",
      url: "/",
      disabled: true,
    },
  ];

  const bannerElements: BannerElement[] = [
    {
      label: "Debtor",
      value: mockData?.debtorName || "-",
    },
    {
      label: "Status",
      value: mockData?.status || "-",
    },
    {
      label: "Submission Date",
      value: mockData?.submissionDate || "-",
    },
  ];

  if (!caseData) return null;

  return (
    <>
      <Breadcrumb items={breadcrumbItems} ariaLabel="Breadcrumb navigation" />
      <Banner
        bannerName="Claim"
        bannerNameValue={submissionId || "-"}
        elements={bannerElements}
      />
    </>
  );
}

export default ClaimSubmissionSummaryHeader;
